import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";
import BlogMainDoctor from '@/views/About/BlogMainDoctor.vue';
import Management from '@/views/About/Management.vue';
import ArticleDetail from '@/views/ArticleDetail.vue';
import About from '@/views/About/About.vue';
import Doctors from '@/views/About/Doctors.vue';
import GeneralInfo from '@/views/About/GeneralInfo.vue';
import PrivacyPolicy from '@/views/About/PrivacyPolicy.vue';
import Schedule from '@/views/About/Schedule.vue';
import Contact from '@/views/About/Contact.vue';
import News from '@/views/About/News.vue';
import Documents from '@/views/About/Documents.vue';
import Vacancies from '@/views/About/Vacancies.vue';
import Reviews from '@/views/About/Reviews.vue';
import LeaveReview from '@/views/About/LeaveReview.vue';
import UnderDepartment from '@/views/Department/UnderDepartment.vue';
import Catamnesis from '@/views/Department/Catamnesis.vue';
import SupportCenter from '@/views/Department/SupportCenter.vue';
import Article from '@/views/Department/Article.vue';
import Services from '@/views/Services.vue'
import ArticleAll from '@/views/ArticleAll.vue'
import Gallery from '@/views/About/Gallery.vue'
import MedicalTourismEnglish from '@/views/Patients/MedicalTourismEnglish.vue'
import Volunteering from '@/views/Education/Volunteering.vue'
import PaidServices from '@/views/PaidServices/PaidServices.vue'
import SchoolOfParents from '@/views/Education/SchoolOfParents.vue'
import DocumentInstitution from '@/views/Documents/DocumentInstitution.vue'
import ItemFolder from '@/views/Documents/ItemFolder.vue'
import DocumentsPatients from '@/views/Documents/DocumentsPatients.vue'
import DocumentsPaidServices from '@/views/Documents/DocumentsPaidServices.vue'
import DocumentsAntiCorruption from '@/views/Documents/DocumentsAntiCorruption.vue'
import DocumentsEducation from '@/views/Documents/DocumentsEducation.vue'
import Education from '@/views/Education/Education.vue'
import Appeal from '@/views/Appeal.vue'
import NotFound from '@/views/NotFound.vue'
import NewsDetail from '@/views/NewsDetail.vue'
import ConsentPage from '@/views/ConsentPage.vue'
import DocumentSpecial from '@/views/Documents/DocumentSpecial.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("../views/HomeRedesign/variants/IndexRedesignA.vue"),
    meta: {
      breadcrumbs: ['Главная'],
      title: "Главная",
      description: "Добро пожаловать на главную страницу центра."
    }
  },
  {
    path: "/home-classic",
    name: "HomeClassic",
    component: Index,
    meta: {
      breadcrumbs: ['Главная'],
      title: "Главная (классическая)",
      description: "Классическая версия главной страницы центра."
    }
  },
  {
    path: "/home-redesign",
    name: "HomeRedesign",
    component: () => import("../views/HomeRedesign/IndexRedesign.vue"),
    meta: {
      title: "Главная (редизайн)",
      description: "Тестовая версия главной страницы перинатального центра ДАР."
    }
  },
  {
    path: "/home-redesign-a",
    redirect: "/",
  },
  {
    path: "/home-redesign-b",
    name: "HomeRedesignB",
    component: () => import("../views/HomeRedesign/variants/IndexRedesignB.vue"),
    meta: {
      title: "Главная B — светлый блок + быстрые ссылки",
      description: "Вариант шапки: светлый блок слева с быстрыми ссылками, фото справа.",
    },
  },
  {
    path: "/home-redesign-c",
    name: "HomeRedesignC",
    component: () => import("../views/HomeRedesign/variants/IndexRedesignC.vue"),
    meta: {
      title: "Главная C — фото + карточка",
      description: "Вариант шапки: полноширинное фото с карточкой и быстрыми ссылками.",
    },
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: {
      breadcrumbs: ['Главная', 'О центре'],
      title: "О центре",
      description: "Информация о центре и его миссии."
    }
  },
  {
    path: "/about/specialists",
    name: "Doctors",
    component: Doctors,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Специалисты'],
      title: "Специалисты",
      description: "Список специалистов центра и их квалификации."
    }
  },
  {
    path: "/about/specialists-grid-test",
    redirect: "/about/specialists",
  },
  {
    path: "/about/general-info",
    name: "GeneralInfo",
    component: GeneralInfo,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Общие сведения'],
      title: "Общие сведения",
      description: "Основная информация о центре."
    }
  },
  {
    path: "/about/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Политика обработки персональных данных'],
      title: "Политика обработки персональных данных",
      description: "Политика обработки персональных данных в соответствии с 152-ФЗ."
    }
  },
  {
    path: "/about/schedule",
    name: "Schedule",
    component: Schedule,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Режим работы'],
      title: "Режим работы",
      description: "График работы центра."
    }
  },
  {
    path: "/about/contacts",
    name: "Contact",
    component: Contact,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Контакты'],
      title: "Контакты",
      description: "Как связаться с нами."
    }
  },
  {
    path: "/about/news",
    name: "News",
    component: News,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Новости'],
      title: "Новости",
      description: "Последние новости и обновления центра."
    }
  },
  {
    path: "/about/news/:id",
    name: "NewsItem",
    component: NewsDetail,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Новости', ':id'],

    }
  },
  {
    path: "/documents",
    name: "Documents",
    component: Documents,
    meta: {
      breadcrumbs: ['Главная', 'Документы'],
      title: "Документы",
      description: "Документы и регламенты центра."
    }
  },
  {
    path: "/about/vacancies",
    name: "Vacancies",
    component: Vacancies,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Вакансии'],
      title: "Вакансии",
      description: "Открытые вакансии в центре."
    }
  },
  {
    path: "/about/reviews",
    name: "Reviews",
    component: Reviews,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Отзывы'],
      title: "Отзывы",
      description: "Отзывы пациентов и их семей."
    }
  },
  {
    path: "/about/reviews/leave",
    name: "LeaveReview",
    component: LeaveReview,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Отзывы', 'Оставить отзыв'],
      title: "Оставить отзыв",
      description: "Форма для отправки отзыва о работе центра."
    }
  },
  {
    path: "/about/gallery",
    name: "Gallery",
    component: Gallery,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Галерея'],
      title: "Галерея",
      description: "Фотографии и галерея центра."
    }
  },
  {
    path: "/about/blog",
    name: "BlogMainDoctor",
    component: BlogMainDoctor,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Блог главного врача'],
      title: "Блог главного врача",
      description: "Блог и статьи от главного врача центра."
    }
  },
  {
    path: "/about/blog/:id",
    name: "ArticleDetail",
    component: ArticleDetail,
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Блог главного врача', ':id'],

    }
  },
  {
    path: "/about/management",
    name: "Management",
    component: Management,
    meta: {
      breadcrumbs: ['Главная', 'О центре', 'Руководство'],
      title: "Руководство",
      description: "Информация о руководстве центра."
    }
  },
  {
    // Старая страница списка отделений отключена; CMS — /department2
    path: "/department",
    redirect: "/department2"
  },
  {
    path: "/department/policlinika",
    redirect: "/department2"
  },
  {
    path: "/department/akusherskij-stacionar",
    redirect: "/department2"
  },
  {
    path: "/department/neonatologicheskij-stacionar",
    redirect: "/department2"
  },
  {
    path: "/department/centr-ginekologii",
    redirect: "/department2"
  },
  {
    path: "/department/laboratornye-i-instrumentalnye-metody-obsledovaniya",
    redirect: "/department2"
  },
  {
    path: "/department/kabinet-katamnesticheskogo-nablyudeniya-za-detmi-s-perinatalnoj-patologiej",
    name: "Отделение катамнестического наблюдения",
    component: Catamnesis,
    meta: {
      breadcrumbs: ['Главная', 'Отделения', 'Отделение катамнестического наблюдения'],
      title: "Отделение катамнестического наблюдения",
      description: "Катамнестическое наблюдение за детьми с перинатальной патологией."
    }
  },
  {
    path: "/department/support-center",
    name: "Центр поддержки",
    component: SupportCenter,
    meta: {
      breadcrumbs: ['Главная', 'Отделения', 'Центр поддержки'],
      title: "Центр поддержки",
      description: "Центр поддержки пациентов и их семей."
    }
  },
  {
    path: "/department/vspomogatelnye-sluzhby",
    redirect: "/department2"
  },
  {
    path: "/:nameDepartment/article/:id",
    name: "ArticleAll",
    component: ArticleAll,
    meta: {
      breadcrumbs: ['Главная', ':nameDepartment', 'Статья:', ':id'],
    }
  },
  {
    path: "/department/:nameDepartment/article/:id",
    name: "Article",
    component: Article,
    meta: {
      breadcrumbs: ['Главная', 'Отделения', ':nameDepartment', 'Статья:', ':id'],

    }
  },
  {
    path: "/family-center",
    redirect: "/family-center2"
  },
  {
    path: "/family-center2",
    name: "FamilyCenterDynamic",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'ЭКО'],
      title: "ЭКО",
      description: "Центр репродуктивной медицины и ЭКО."
    }
  },
  {
    path: "/family-center/:pathMatch(.*)",
    redirect: "/family-center2"
  },
  {
    path: "/pregnancy",
    redirect: "/pregnancy2"
  },
  {
    path: "/pregnancy2",
    name: "PregnancyDynamic",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Беременность'],
      title: "Беременность",
      description: "Информация и услуги для беременных женщин."
    }
  },
  {
    path: "/pregnancy/:pathMatch(.*)",
    redirect: "/pregnancy2"
  },
  {
    path: "/newborn",
    redirect: "/newborn_new"
  },
  {
    path: "/newborn2",
    redirect: "/newborn_new"
  },
  {
    path: "/newborn_new",
    name: "NewbornDynamic",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Плод и новорожденный'],
      title: "Плод и новорожденный",
      description: "Уход и медицинская помощь для новорожденных."
    }
  },
  {
    path: "/newborn/:pathMatch(.*)",
    redirect: "/newborn_new"
  },
  {
    path: "/newborn2/:pathMatch(.*)",
    redirect: "/newborn_new"
  },
  {
    path: "/childbirth",
    redirect: "/rody1"
  },
  {
    path: "/rody1",
    name: "ChildbirthDynamic",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Роды'],
      title: "Роды",
      description: "Информация о родах и поддержке."
    }
  },
  {
    path: "/childbirth/:pathMatch(.*)",
    redirect: "/rody1"
  },
  {
    path: "/services",
    name: "Services",
    component: Services,
    meta: {
      breadcrumbs: ['Главная', 'Услуги'],
      title: "Услуги",
      description: "Все услуги, предоставляемые нашим центром."
    }
  },
  {
    path: "/department/:nameDepartment/:name",
    name: "UnderDepartment",
    component: UnderDepartment,
    meta: {
      breadcrumbs: ['Главная', 'Отделения', ':nameDepartment', ':name'],
      title: "Подотделение",
      description: "Информация о конкретном подотделении."
    }
  },
  {
    path: "/oms",
    redirect: "/oms2"
  },
  {
    path: "/oms2",
    name: "Услуги ОМС",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Услуги ОМС'],
      title: "Услуги ОМС",
      description: "Информация о предоставляемых услугах по ОМС."
    }
  },
  {
    path: "/oms/:pathMatch(.*)",
    redirect: "/oms2"
  },
  {
    path: "/rules",
    redirect: "/rules2"
  },
  {
    path: "/rules2",
    name: "Правила записи на прием",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Правила записи на прием'],
      title: "Правила записи на прием",
      description: "Условия и правила записи на прием."
    }
  },
  {
    path: "/rules/:pathMatch(.*)",
    redirect: "/rules2"
  },
  {
    path: "/tests",
    redirect: "/tests2"
  },
  {
    path: "/tests2",
    name: "Анализы",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Анализы'],
      title: "Анализы",
      description: "Информация об анализах, доступных в центре."
    }
  },
  {
    path: "/tests/:pathMatch(.*)",
    redirect: "/tests2"
  },
  {
    path: "/hospitalization",
    redirect: "/hospitalization2"
  },
  {
    path: "/hospitalization2",
    name: "Госпитализация",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Госпитализация'],
      title: "Госпитализация",
      description: "Условия и процедура госпитализации."
    }
  },
  {
    path: "/hospitalization/:pathMatch(.*)",
    redirect: "/hospitalization2"
  },
  {
    path: "/foreigners",
    redirect: "/foreigners2"
  },
  {
    path: "/foreigners2",
    name: "Иностранным гражданам",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Иностранным гражданам'],
      title: "Иностранным гражданам",
      description: "Медицинские услуги для иностранных граждан."
    }
  },
  {
    path: "/foreigners/:pathMatch(.*)",
    redirect: "/foreigners2"
  },
  {
    path: "/tax-refund",
    redirect: "/tax-refund2"
  },
  {
    path: "/tax-refund2",
    name: "Справка для налогового вычета",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Справка для налогового вычета'],
      title: "Справка для налогового вычета",
      description: "Получение справки для налогового вычета на лечение."
    }
  },
  {
    path: "/tax-refund/:pathMatch(.*)",
    redirect: "/tax-refund2"
  },
  {
    path: "/schedule",
    redirect: "/schedule2"
  },
  {
    path: "/schedule2",
    name: "График приема граждан",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'График приема граждан'],
      title: "График приема граждан",
      description: "Расписание приема граждан в центре."
    }
  },
  {
    path: "/schedule/:pathMatch(.*)",
    redirect: "/schedule2"
  },
  {
    path: "/list-product",
    redirect: "/list-product2"
  },
  {
    path: "/list-product2",
    name: "Список продуктов для передачи",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Список продуктов для передачи'],
      title: "Список продуктов для передачи",
      description: "Рекомендованный список продуктов для передачи пациентам."
    }
  },
  {
    path: "/list-product/:pathMatch(.*)",
    redirect: "/list-product2"
  },
  {
    path: "/prayer-room",
    redirect: "/prayer-room2"
  },
  {
    path: "/prayer-room2",
    name: "Молитвенная комната",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Молитвенная комната'],
      title: "Молитвенная комната",
      description: "Молитвенная комната для посетителей центра."
    }
  },
  {
    path: "/prayer-room/:pathMatch(.*)",
    redirect: "/prayer-room2"
  },
  {
    path: "/medical-tourism",
    redirect: "/medical-tourism2"
  },
  {
    path: "/medical-tourism2",
    name: "Медицинский туризм",
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Медицинский туризм'],
      title: "Медицинский туризм",
      description: "Услуги медицинского туризма для иностранных пациентов."
    }
  },
  {
    path: "/medical-tourism/:pathMatch(.*)",
    redirect: "/medical-tourism2"
  },
  {
    path: "/medical-tourism-english",
    name: "Медицинский туризм English",
    component: MedicalTourismEnglish,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Медицинский туризм English'],
      title: "Medical Tourism",
      description: "Medical tourism services for foreign patients."
    }
  },
  {
    path: "/education/volunteer-activities",
    name: "Волонтерство",
    component: Volunteering,
    meta: {
      breadcrumbs: ['Главная', 'Образование', 'Волонтерство'],
      title: "Волонтерство",
      description: "Волонтерские программы в центре."
    }
  },
  {
    path: "/paid-services",
    name: "Платные услуги",
    component: PaidServices,
    meta: {
      breadcrumbs: ['Главная', 'Пациентам', 'Платные услуги и цены'],
      title: "Платные услуги и цены",
      description: "Актуальный прайс на платные медицинские услуги центра."
    }
  },
  {
    path: "/education/school-of-parents",
    name: "Школа будущих родителей",
    component: SchoolOfParents,
    meta: {
      breadcrumbs: ['Главная', 'Образование', 'Школа будущих родителей'],
      title: "Школа будущих родителей",
      description: "Образовательная программа для будущих родителей."
    }
  },
  {
    path: "/documents/institution",
    name: "Документы учреждения",
    component: DocumentInstitution,
    meta: {
      breadcrumbs: ['Главная', 'Документы', 'Документы учреждения'],
      title: "Документы учреждения",
      description: "Официальные документы и лицензии центра."
    }
  },
  {
    path: "/documents/education",
    name: "Образование",
    component: DocumentsEducation,
    meta: {
      breadcrumbs: ['Главная', 'Документы', 'Образование'],
      title: "Документы по образованию",
      description: "Документы об образовательных программах."
    }
  },
  {
    path: "/documents/patients",
    name: "Документы пациентам",
    component: DocumentsPatients,
    meta: {
      breadcrumbs: ['Главная', 'Документы', 'Пациентам'],
      title: "Документы пациентам",
      description: "Необходимые документы для пациентов центра."
    }
  },
  {
    path: "/documents/paid-services",
    name: "Документы платные услуги",
    component: DocumentsPaidServices,
    meta: {
      breadcrumbs: ['Главная', 'Документы', 'Платные услуги'],
      title: "Документы платные услуги",
      description: "Документы для предоставления платных услуг."
    }
  },
  {
    path: "/documents/anti-corruption",
    name: "Противодействие коррупции",
    component: DocumentsAntiCorruption,
    meta: {
      breadcrumbs: ['Главная', 'Документы', 'Противодействие коррупции'],
      title: "Противодействие коррупции",
      description: "Меры по противодействию коррупции в центре."
    }
  },
  {
    path: "/documents/special-assessment",
    name: "Специальная оценка условий труда",
    component: DocumentSpecial,
    meta: {
      breadcrumbs: ['Главная', 'Документы', 'Специальная оценка условий труда'],
      title: "Специальная оценка условий труда",
      description: "Специальная оценка условий труда."
    }
  },
  {
    path: "/documents/:nameFolder/:name",
    name: "FolderDetails",
    component: ItemFolder,
    meta: {
      breadcrumbs: ['Главная', 'Документы', ':nameFolder', ':name'],
      title: "Подробности папки",
      description: "Просмотр содержимого выбранной папки."
    }
  },
  {
    path: "/documents/:nameFolder/:name/:nextName",
    name: "NextFolderDetails",
    component: ItemFolder,
    meta: {
      breadcrumbs: ['Главная', 'Документы', ':nameFolder', ':name', ':nextName'],
      title: "Детали подкаталога",
      description: "Просмотр содержимого выбранного подкаталога."
    }
  },
  {
    path: "/education",
    name: "Education",
    component: Education,
    meta: {
      breadcrumbs: ['Главная', 'Образование'],
      title: "Образование",
      description: "Образовательные программы и курсы центра."
    }
  },
  {
    path: "/appeal",
    name: "Appeal",
    component: Appeal,
    meta: {
      breadcrumbs: ['Главная', 'Написать обращение'],
      title: "Обращение",
      description: "Форма для отправки обращения в центр."
    }
  },
  {
    path: "/appeal/consent",
    name: "Consent",
    component: ConsentPage,
    meta: {
      breadcrumbs: ['Главная', 'Написать обращение', 'Согласие на обработку данных'],
      title: "Согласие на обработку данных",
      description: "Согласие на обработку персональных данных."
    }
  },

  {
    path: "/sitemap",
    name: "Sitemap",
    component: () => import("../views/Sitemap.vue"),
    meta: {
      breadcrumbs: ['Главная', 'Карта сайта'],
      title: "Карта сайта",
      description: "Структура сайта Алтайского краевого клинического перинатального центра ДАР."
    }
  },

  // appeal
  // динамический маршрут для всех slug страниц (до catch-all *)
  {
    path: '/:slug+',
    name: 'DynamicPage',
    component: () => import('@/views/DynamicPage.vue'),
    props: true,
    meta: {
      includeInSearch: false
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      breadcrumbs: ['Главная', 'Не найдено'],
      includeInSearch: false
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.querySelector(to.hash);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          resolve(false);
        }, 100);
      });
    }
    return { x: 0, y: 0 };
  },
});

export default router;
